import { SchoolAdminEditPage } from "./page"

export default SchoolAdminEditPage
